import React from "react";
import moment from "moment";
import { FormRangeEndDatePicker } from "components/DatePicker/RangeDatePicker";
import { getInvoiceDueDate } from "utilities/invoiceUtils";

interface Props {
  onChange: (value: moment.Moment, dueInDays: number, fromCalendar: boolean) => void;
  minDate?: moment.Moment;
  sendDate: moment.Moment;
  dueInDays: number;
  inPageEdit?: {
    cancel: () => void;
    submit: () => void;
  }
}

export const DocumentDueDatePicker = (props: Props) => {
  const { sendDate, onChange, dueInDays, inPageEdit } = props;

  const dueDate = getInvoiceDueDate(sendDate, dueInDays);

  const maxDate = sendDate.clone().add(serverReference.constants.invoice.maxDueInDays, "days");

  const getNewDueInDays = (v: moment.Moment) => v.diff(sendDate, "days");

  return (
    <FormRangeEndDatePicker
      validatorKey="dueDate"
      minDate={props.minDate ?? sendDate}
      maxDate={maxDate}
      value={dueDate}
      onChange={(v, fromCalendar) => onChange(v, getNewDueInDays(v), fromCalendar)}
      rangeStart={sendDate}

      focusOnMount={inPageEdit != null}
      onEsc={inPageEdit?.cancel}
      onEnter={inPageEdit?.submit}
    />
  );
};

export default DocumentDueDatePicker;
